import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Sidebar from '../components/Sidebar'
function Dashboard() {
  return (
    <div>
      <Header />
      <section className="dashboard">
<div className="container mb-5">        
        <div className="row my-5 g-0">           
           <Sidebar />
            <div className="col-md-10">
                <h1>Dashboard</h1>
                <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            </div>           
        </div> 
</div>
</section>

    <Footer />
    </div>
  )
}

export default Dashboard